import React, { useState } from "react";
import styles from "./Row.module.sass";
import ModalProduct from "../../ModalProduct";
import Icon from "../../Icon";
import Actions from "../../Actions";
import Modal from "../../Modal";
import Schedule from "../../Schedule";
import Control from "./Control";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import { useHistory } from "react-router";
import Confirm from "../../Confirm";
import { UseApi } from "../../../hooks/use-api";
import { UpdateCollection } from "../../../Services/lib/nft";
import { ValidatorCollection } from "../../../Services/assets/collection-validator";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";

const Row = ({ item, fetchCollections }) => {
	const history = useHistory();
	const [startDate, setStartDate] = useState(new Date());
	const [{ isLoading }, update] = UseApi({
		service: UpdateCollection,
	});
	const date = new Date(
		item.status === "DRAFT" ? item.updatedAt : item.startDate
	);
	const [visibleModalProduct, setVisibleModalProduct] = useState(false);
	const [visibleModalSchedule, setVisibleModalSchedule] = useState(false);
	const { isOpen, onClose, onOpen } = UseDisclosure();

	const onConfirm = async () => {
		const res = await update({
			_id: item._id,
			status: "DRAFT",
			startDate: null,
		});
		if (res) {
			fetchCollections();
		}
	};
	const Submit = async () => {
		const res = await update({
			_id: item._id,
			startDate,
		});
		if (res) {
			fetchCollections();
		}
	};

	const actions =
		item.status === "DRAFT"
			? [
					{
						title: "Schedule product",
						icon: "calendar",
						action: () => {
							const missingFields = ValidatorCollection(item);
							if (Object.keys(missingFields).length === 0) {
								setVisibleModalSchedule(true);
							} else {
								ToastEmitter({
									type: "info",
									msg: "You cannot publish a collection that has missing fields",
								});
							}
						},
					},
					{
						title: "Edit title & description",
						icon: "edit",
						action: () => history.push("/products/edit/" + item._id),
					},
					{
						title: "Delete forever",
						icon: "trash",
						action: () => console.log("Delete forever"),
					},
			  ]
			: [
					{
						title: "Discard scheduled",
						icon: "trash",
						action: onOpen,
					},
			  ];

	return (
		<>
			<div className={styles.row}>
				<div className={styles.col}>
					{/* <Checkbox
						className={styles.checkbox}
						value={value}
						onChange={onChange}
					/> */}
				</div>
				<div className={styles.col}>
					<div
						className={styles.item}
						onClick={() => setVisibleModalProduct(true)}
					>
						<div className={styles.preview}>
							<img srcSet={`${item.image} 2x`} src={item.image} alt="Product" />
						</div>
						<div className={styles.details}>
							<div className={styles.product}>{item.name}</div>
							<div className={styles.link}>{item.link}</div>
							<div className={styles.date}>
								<Icon name="clock" size="20" /> {date.toLocaleString()}
							</div>
							{/* {item.price > 0 ? (
								<div className={styles.price}>${item.price}</div>
							) : (
								<div className={styles.empty}>${item.price}</div>
							)} */}
						</div>
					</div>
					<Actions
						className={styles.actions}
						classActionsHead={styles.actionsHead}
						items={actions}
					/>
				</div>
				{/* <div className={styles.col}>
					{item.price > 0 ? (
						<div className={styles.price}>${item.price}</div>
					) : (
						<div className={styles.empty}>${item.price}</div>
					)}
				</div> */}
				<div className={styles.col}>{date.toLocaleString()}</div>
				<div className={styles.col}>
					{item.creator?.userName}
					<Control
						isLoading={isLoading}
						Submit={Submit}
						onOpen={onOpen}
						item={item}
						className={styles.control}
						startDate={startDate}
						setStartDate={setStartDate}
					/>
				</div>
			</div>
			<ModalProduct
				item={item}
				visible={visibleModalProduct}
				onClose={() => setVisibleModalProduct(false)}
			/>
			<Modal
				visible={visibleModalSchedule}
				onClose={() => setVisibleModalSchedule(false)}
			>
				<Schedule
					isLoading={isLoading}
					action="Publish"
					onClick={Submit}
					startDate={startDate}
					setStartDate={setStartDate}
				/>
			</Modal>
			<Modal visible={isOpen} onClose={onClose}>
				<Confirm
					title="That action will move this collection to DRAFT."
					onCancel={onClose}
					onConfirm={onConfirm}
					isLoading={isLoading}
				/>
			</Modal>
		</>
	);
};

export default Row;
